import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the appAdvisorResultsSlice slice
const initialState = {
  "appadvisor-turboflow": {
    history: [],
  },
  evaluatedStep: null,
  currentStep: null,
  evaluatedStage: null,
  currentStage: null,
  visitedItems: {
    selected: []
  },
  selectedProject:
  {
    "id": 0,
    "ProjectName": "",
    "ProjectID": "",
    "ProjectLastModifiedDate": "",
    "CurrentStage": "",
    "CurrentStep": "",
    "WizardStageSelected": "",
    "WizardStepSelected": "",
    UsedMLO: false,
    MLOUsage: []
  }
  ,
  stepStatus: [{ stage: null, selectedSteps: [''] }],
  deepLinkProduct: {},
  projects:[],
  isProjectCreatedFromMLO:false,
  isUnlinkFromMLO:false
};

// Create the appAdvisorResultsSlice slice using createSlice
const appAdvisorResultsSlice = createSlice({
  name: "appAdvisoeResults", // Slice name
  initialState, // Initial state
  reducers: {
    // Reducer functions to update the state
    updateAppAdvisorResults(state, action) {
      state["appadvisor-turboflow"] =
        action.payload["appadvisor-turboflow"] ??
        state["appadvisor-turboflow"];
      state.currentStage =
        action.payload.currentStage ?? state.currentStage;
      state.currentStep =
        action.payload.currentStep ?? state.currentStep;
      state.deepLinkProduct =
        action.payload.deepLinkProduct ?? state.deepLinkProduct;
      state.evaluatedStage =
        action.payload.evaluatedStage ?? state.evaluatedStage;
      state.evaluatedStep =
        action.payload.evaluatedStep ?? state.evaluatedStep;
      state.visitedItems =
        action.payload.visitedItems ?? state.visitedItems;
      state.stepStatus =
        action.payload.stepStatus ?? state.stepStatus;
      state.selectedProject = action.payload.selectedProject ?? state.selectedProject;
      state.projects = action.payload.projects ?? state.projects;
      state.isProjectCreatedFromMLO = action.payload.isProjectCreatedFromMLO ?? state.isProjectCreatedFromMLO;
      state.isUnlinkFromMLO = action.payload.isUnlinkFromMLO ?? state.isUnlinkFromMLO;
    },

    resetAppAdvisorResults(state, action) {
        state["appadvisor-turboflow"] =
        initialState["appadvisor-turboflow"];
      state.currentStage =
       initialState.currentStage;
      state.currentStep =
        initialState.currentStep;
      state.deepLinkProduct =
        initialState.deepLinkProduct;
      state.evaluatedStage =
        initialState.evaluatedStage;
      state.evaluatedStep =
       initialState.evaluatedStep;
      state.visitedItems =
        initialState.visitedItems;
      state.stepStatus = initialState.stepStatus;
      state.selectedProject = initialState.selectedProject;
      state.projects = initialState.projects;
      state.isProjectCreatedFromMLO = initialState.isProjectCreatedFromMLO;
      state.isUnlinkFromMLO = initialState.isUnlinkFromMLO;
    },
  },
});

// Export the reducer functions as actions
export const {
  updateAppAdvisorResults,
  resetAppAdvisorResults
} = appAdvisorResultsSlice.actions;
// Export the reducer function itself
export default appAdvisorResultsSlice.reducer;
